const UPDATE_LOADING_SCREEN = 'UPDATE_LOADING_SCREEN';
const SHOW_ALERT = 'SHOW_ALERT';
const USER_LOGIN = 'USER_LOGIN';
const LOGOUT = 'LOGOUT'
const AUTH_LOADED = 'AUTH_LOADED'
export const actionTypes = {
    UPDATE_LOADING_SCREEN,
    USER_LOGIN,
    SHOW_ALERT,
    LOGOUT,
    AUTH_LOADED,
};